module.exports = __webpack_public_path__ + "public/images/avatar.615816c3dba2518e700b8feca5eefb82.webp";